import { createSelector } from 'reselect';
import { rootSelector } from '../../root-selector';

export const dancersSelector = createSelector(
  rootSelector,
  state => state.dancersSlice.dancersSlice && state.dancersSlice.dancersSlice.dancers
);
